// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16dr_","col":"styles_col__mVRrC","actions":"styles_actions__2wv2Z","conflict":"styles_conflict__25bjv"};